/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Title_AllInputs */

const en_directory_title_all = /** @type {(inputs: Directory_Title_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a specialist`)
};

const pl_directory_title_all = /** @type {(inputs: Directory_Title_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź specjalistę`)
};

/**
* | output |
* | --- |
* | "Find a specialist" |
*
* @param {Directory_Title_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_title_all = /** @type {((inputs?: Directory_Title_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Title_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_title_all(inputs)
	return en_directory_title_all(inputs)
});